import { MenuItemInfo } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { Domain } from '~src/settings/bridge-settings/sections/types/Domain';

import { textCellPadding } from '../dataConnectMultiCluster/DataConnectMultiClusterTableHeaders';
import { ActionItemInfo, ActionItemType, ActionType, MoreActionsMenu } from '../MoreActionsMenu';
import { PoolID } from '../types/PoolID';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { openEditPoolDomainDialog } from './addNewDomainDialog/EditDomainDialog';
import { openDeletePoolDomainDialog } from './deleteDomainConfirmationDialog/DeleteDomainConfirmationDialog';
import { openMovePoolDomainDialog } from './moveDomainDialog/MoveDomainDialog';


export type DataConnectPoolDomainsTableRowProps = Readonly<{
  domain: Domain;
  index: number;
  siteId: string;
  poolId: PoolID;
  poolName: string;
  userDefinedPools: Record<string, UserDefinedPoolModel>;
  bridgeDomains: Record<string, Domain>;
  poolTestId: string;
  refreshPoolsAndClusters: () => void;
}>;


export function DataConnectPoolDomainsTableRow(props: DataConnectPoolDomainsTableRowProps) {
  const {   index, siteId, poolId, poolName, poolTestId, domain , userDefinedPools, bridgeDomains, refreshPoolsAndClusters } = props;
  const cellClass =  textCellPadding + ' tb-data-grid-separator-row';

  const targetSelectItem: MenuItemInfo[] = [
    { displayValue: Messages.dataConnectSiteSettingsEditDomainButton(), value: ActionType.EDIT_POOL_DOMAIN},
    { displayValue: Messages.dataConnectSiteSettingsMoveDomainButton(), value: ActionType.MOVE_POOL_DOMAIN},
    { displayValue: Messages.deleteMessage(), value: ActionType.DELETE_POOL_DOMAIN},
  ];

  return <>
    <td className={cellClass} style={{paddingLeft: 3}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'domain-name-cell' + poolTestId}>
        {domain.domainName}
      </span>
    </td>
    <td className={cellClass} style={{paddingLeft: 12}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'domain-domainPermission-cell' + poolTestId}>
        {Messages.dataConnectSiteSettingsDomainAccessAllow()}
      </span>
    </td>
    <td className={cellClass} style={{paddingLeft: 15, maxWidth: 13}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'domain-actions-cell' + poolTestId}>
        <MoreActionsMenu
          targetItemInfo={targetSelectItem}
          actionType= {ActionItemType.NODE_ACTION}
          actionItemInfo={{poolId: poolId, poolName: poolName,  siteId: siteId,
                      domain: domain, userDefinedPools: userDefinedPools,
                      bridgeDomains: bridgeDomains,
                      refreshPoolsAndClusters: refreshPoolsAndClusters }}
          onHandleMenuSelect={onHandleMenuSelect}
        />
       </span>
    </td>
  </>;
}


const onHandleMenuSelect = (actionItem: ActionItemInfo, actionType: string) => {
    if (actionType === ActionType.EDIT_POOL_DOMAIN) {
      openEditPoolDomainDialog(actionItem);
    } else if (actionType === ActionType.DELETE_POOL_DOMAIN) {
      openDeletePoolDomainDialog(actionItem);
    } else if (actionType === ActionType.MOVE_POOL_DOMAIN) {
      openMovePoolDomainDialog(actionItem);
    }

};
